function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
var LoginMainComponentCtrl = /*#__PURE__*/function () {
  LoginMainComponentCtrl.$inject = ["$log", "$timeout", "$state", "vcRecaptchaService", "AccesoDatos"];
  function LoginMainComponentCtrl($log, $timeout, $state, vcRecaptchaService, AccesoDatos) {
    _classCallCheck(this, LoginMainComponentCtrl);
    // empresa!: string
    _defineProperty(this, "form", {
      username: '',
      pass: '',
      recapResponse: null
    });
    _defineProperty(this, "errorcapt", false);
    // si no se marca el catpcha
    _defineProperty(this, "recaptchaACTIVO", false);
    _defineProperty(this, "closeWindow", false);
    this.$log = $log;
    this.$timeout = $timeout;
    this.$state = $state;
    this.vcRecaptchaService = vcRecaptchaService;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(LoginMainComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info('[LoginMainComponentCtrl] onInit');
    }
  }, {
    key: "gologin",
    value: function gologin() {
      var _this = this;
      // this.vcRecaptchaService.execute();

      this.$log.info('login', this.form);
      if (this.recaptchaACTIVO && !this.validaRecaptcha()) {
        return;
      }
      var pet = {
        username: this.form.username,
        pass: this.form.pass,
        verify: this.form.recapResponse,
        ip: undefined
      };
      this.AccesoDatos.Login_CLIENT.login(pet) //
      .then(function (appstateResponse) {
        var _goBack = window.location.href.includes('_back=1');
        if (_goBack) {
          _this.closeWindow = true;
          window.close();
          return;
        }
        if (_this.seccionCuestionarios) {
          _this.$state.go('cuestionarios.priv.startpriv');
        } else if (appstateResponse.adm) {
          _this.$state.go('priv.main');
        } else {
          _this.$state.go('priv.main.myforms');
        }
      });
    }
  }, {
    key: "testClose",
    value: function testClose() {
      this.closeWindow = true;
      try {
        window.close();
      } catch (err) {
        this.$log.error('Error cerrando ventana', err);
      }
    }
  }, {
    key: "validaRecaptcha",
    value: function validaRecaptcha() {
      var recapResponse = this.vcRecaptchaService.getResponse(); // returns the string response

      if (recapResponse == '') {
        this.errorcapt = true;
        return false;
      }
      this.$log.info('recaptcha', recapResponse);
      return true;
    }
  }]);
}();
angular.module('candidato').component('loginMain', {
  bindings: {
    // empresa: "<",
    seccionCuestionarios: '<'
  },
  controller: LoginMainComponentCtrl,
  // templateUrl: "login-main.component.html",
  template: require('./login-main.component.html')
});